import { render, staticRenderFns } from "./showPublicComponent.vue?vue&type=template&id=26c330ec&"
import script from "./showPublicComponent.vue?vue&type=script&lang=js&"
export * from "./showPublicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports